 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER301TUSKDESCENDING from '@/components/0_chapter301tuskdescending'
 import A_CHAPTER302SAVETHEPOOROFASMALLTOWN from '@/components/1_chapter302savethepoorofasmalltown'
 import A_CHAPTER303RALLYING from '@/components/2_chapter303rallying'
 import A_CHAPTER304INTHENAMEOFTHEQINEMPEROR from '@/components/3_chapter304inthenameoftheqinemperor'
 import A_CHAPTER305MYSTERIOUSMAN from '@/components/4_chapter305mysteriousman'
 import A_CHAPTER306CROSSCOUNTING from '@/components/5_chapter306crosscounting'
 import A_CHAPTER307YANGTIANSDANGER from '@/components/6_chapter307yangtiansdanger'
 import A_CHAPTER308MYSTERIOUSINJECTION from '@/components/7_chapter308mysteriousinjection'
 import A_CHAPTER309ENIGMATIC from '@/components/8_chapter309enigmatic'
 import A_CHAPTER310VIRUSREAPPEARANCE from '@/components/9_chapter310virusreappearance'
 import A0_CHAPTER311NOVELVIRUS from '@/components/10_chapter311novelvirus'
 import A1_CHAPTER312WHOSTHEBOSS from '@/components/11_chapter312whostheboss'
 import A2_CHAPTER313AIRBORNEISLAND from '@/components/12_chapter313airborneisland'
 import A3_CHAPTER314ISLANDCRISIS from '@/components/13_chapter314islandcrisis'
 import A4_CHAPTER315STRANGESTONEHOUSE from '@/components/14_chapter315strangestonehouse'
 import A5_CHAPTER316THEMONSTERAPPEARSAGAIN from '@/components/15_chapter316themonsterappearsagain'
 import A6_CHAPTER317OVERON from '@/components/16_chapter317overon'
 import A7_CHAPTER318BRINGHIMBACK from '@/components/17_chapter318bringhimback'
 import A8_CHAPTER319NATIONALRESCUE from '@/components/18_chapter319nationalrescue'
 import A9_CHAPTER320RECEPTIONATHOME from '@/components/19_chapter320receptionathome'
 import A0_CHAPTER321BANQUET from '@/components/20_chapter321banquet'
 import A1_CHAPTER322PROVOKEBYTHESECURITYGUARD from '@/components/21_chapter322provokebythesecurityguard'
 import A2_CHAPTER323KANKAISATTITUDE from '@/components/22_chapter323kankaisattitude'
 import A3_CHAPTER324VARIOUSTAUNTS from '@/components/23_chapter324varioustaunts'
 import A4_CHAPTER325KANKAISTHOUGHTS from '@/components/24_chapter325kankaisthoughts'
 import A5_CHAPTER326EMOTIONALCONFESSION from '@/components/25_chapter326emotionalconfession'
 import A6_CHAPTER327BANQUETASSASSINATION from '@/components/26_chapter327banquetassassination'
 import A7_CHAPTER328SEARCHFORGHOSTS from '@/components/27_chapter328searchforghosts'
 import A8_CHAPTER329EVOKEINNERGHOSTS from '@/components/28_chapter329evokeinnerghosts'
 import A9_CHAPTER330MERCENARYFORBIDDENAREA from '@/components/29_chapter330mercenaryforbiddenarea'
 import A0_CHAPTER331PRETENDTOBECAPTURED from '@/components/30_chapter331pretendtobecaptured'
 import A1_CHAPTER332THESEVERITYOFDESPAIR from '@/components/31_chapter332theseverityofdespair'
 import A2_CHAPTER333TOTALDESPAIR from '@/components/32_chapter333totaldespair'
 import A3_CHAPTER334THEFINALPATHOFARIGIDWIDTH from '@/components/33_chapter334thefinalpathofarigidwidth'
 import A4_CHAPTER335EERIEINSECT from '@/components/34_chapter335eerieinsect'
 import A5_CHAPTER336TENNAMES from '@/components/35_chapter336tennames'
 import A6_CHAPTER337TRACING from '@/components/36_chapter337tracing'
 import A7_CHAPTER338BACKTOTHERIVER from '@/components/37_chapter338backtotheriver'
 import A8_CHAPTER339MISUNDERSTANDINGCONFESSIONS from '@/components/38_chapter339misunderstandingconfessions'
 import A9_CHAPTER340DARKSUBSTANCE from '@/components/39_chapter340darksubstance'
 import A0_CHAPTER341WEBROKEUP from '@/components/40_chapter341webrokeup'
 import A1_CHAPTER342DEVILISLAND from '@/components/41_chapter342devilisland'
 import A2_CHAPTER343HECAME from '@/components/42_chapter343hecame'
 import A3_CHAPTER344BLOODYSLAUGHTER from '@/components/43_chapter344bloodyslaughter'
 import A4_CHAPTER345ADRAGONSINVERSESCALETOUCHDYING from '@/components/44_chapter345adragonsinversescaletouchdying'
 import A5_CHAPTER346SAFERETURN from '@/components/45_chapter346safereturn'
 import A6_CHAPTER347BETWEENTHREEPEOPLE from '@/components/46_chapter347betweenthreepeople'
 import A7_CHAPTER348ACONTESTACROSSTHEAIR from '@/components/47_chapter348acontestacrosstheair'
 import A8_CHAPTER349MESSAGEFROMYANGTIAN from '@/components/48_chapter349messagefromyangtian'
 import A9_CHAPTER350FIELDGAP from '@/components/49_chapter350fieldgap'
 import A0_CHAPTER351MYSTERIOUS from '@/components/50_chapter351mysterious'
 import A1_CHAPTER352CAPTURETASK from '@/components/51_chapter352capturetask'
 import A2_CHAPTER353SOCALLEDIMMORTALITY from '@/components/52_chapter353socalledimmortality'
 import A3_CHAPTER354MYSTERIOUSLAND from '@/components/53_chapter354mysteriousland'
 import A4_CHAPTER355EASTAFRICAGREATRIFTVALLEY from '@/components/54_chapter355eastafricagreatriftvalley'
 import A5_CHAPTER356NINEDEADANDONEALIVE from '@/components/55_chapter356ninedeadandonealive'
 import A6_CHAPTER357ROOTLESSWATER from '@/components/56_chapter357rootlesswater'
 import A7_CHAPTER358LIWUSESREQUEST from '@/components/57_chapter358liwusesrequest'
 import A8_CHAPTER359THEENMITYBETWEENTHEEXTERMINATIONOFONESCLANANDTHEEXTERMINATIONOFANOTHERWASIRRECONCILABLE from '@/components/58_chapter359theenmitybetweentheexterminationofonesclanandtheexterminationofanotherwasirreconcilable'
 import A9_CHAPTER360COSTOFABROKENARM from '@/components/59_chapter360costofabrokenarm'
 import A0_CHAPTER361PARSONCONSORTIUM from '@/components/60_chapter361parsonconsortium'
 import A1_CHAPTER362QINCHUANSHEART from '@/components/61_chapter362qinchuansheart'
 import A2_CHAPTER363ONEPARENTSQUARE from '@/components/62_chapter363oneparentsquare'
 import A3_CHAPTER364THEXUEFAMILYSCRISIS from '@/components/63_chapter364thexuefamilyscrisis'
 import A4_CHAPTER365XUEFAMILYSATTITUDE from '@/components/64_chapter365xuefamilysattitude'
 import A5_CHAPTER366XUEFAMILYSREQUEST from '@/components/65_chapter366xuefamilysrequest'
 import A6_CHAPTER36710BILLION from '@/components/66_chapter36710billion'
 import A7_CHAPTER368ASTRANGELITTLETOWN from '@/components/67_chapter368astrangelittletown'
 import A8_CHAPTER369MUTANT from '@/components/68_chapter369mutant'
 import A9_CHAPTER370DEEPINMINE from '@/components/69_chapter370deepinmine'
 import A0_CHAPTER371THREESECONDMIRACLE from '@/components/70_chapter371threesecondmiracle'
 import A1_CHAPTER372KILLING from '@/components/71_chapter372killing'
 import A2_CHAPTER373RESCUEHOSTAGES from '@/components/72_chapter373rescuehostages'
 import A3_CHAPTER374SONICATTACKTOTHEWEST from '@/components/73_chapter374sonicattacktothewest'
 import A4_CHAPTER375DISGUISE from '@/components/74_chapter375disguise'
 import A5_CHAPTER376FALSELYTRUE from '@/components/75_chapter376falselytrue'
 import A6_CHAPTER377DELIBERATEPROBING from '@/components/76_chapter377deliberateprobing'
 import A7_CHAPTER378SECRETBASE from '@/components/77_chapter378secretbase'
 import A8_CHAPTER379THESECRETOFTHEBASE from '@/components/78_chapter379thesecretofthebase'
 import A9_CHAPTER380ATESTOFFALSEVULGARITY from '@/components/79_chapter380atestoffalsevulgarity'
 import A0_CHAPTER381UPLIFTSPEECH from '@/components/80_chapter381upliftspeech'
 import A1_CHAPTER382HUAROUDANGER from '@/components/81_chapter382huaroudanger'
 import A2_CHAPTER383SNEAKINGIN from '@/components/82_chapter383sneakingin'
 import A3_CHAPTER384CRAZYSIDE from '@/components/83_chapter384crazyside'
 import A4_CHAPTER385THEAPOCALYPSEISCOMING from '@/components/84_chapter385theapocalypseiscoming'
 import A5_CHAPTER386PAST from '@/components/85_chapter386past'
 import A6_CHAPTER387ROLEOFTHEBODY from '@/components/86_chapter387roleofthebody'
 import A7_CHAPTER388ONEYEARLATER from '@/components/87_chapter388oneyearlater'
 import A8_CHAPTER389THEDANCEOFFIREANDTHEGOLDENCHILD from '@/components/88_chapter389thedanceoffireandthegoldenchild'
 import A9_CHAPTER390GENIUSOFVARIOUSRACES from '@/components/89_chapter390geniusofvariousraces'
 import A0_CHAPTER391SUNCHOUSCHEAPSHOT from '@/components/90_chapter391sunchouscheapshot'
 import A1_CHAPTER392DARKALLIANCE from '@/components/91_chapter392darkalliance'
 import A2_CHAPTER393SNOWSTORMSKYCURTAIN from '@/components/92_chapter393snowstormskycurtain'
 import A3_CHAPTER394YOUARESUCHAPERVERT from '@/components/93_chapter394youaresuchapervert'
 import A4_CHAPTER395CRAZYASTHEQINEMPEROR from '@/components/94_chapter395crazyastheqinemperor'
 import A5_CHAPTER396YOUDONTKNOWHIM from '@/components/95_chapter396youdontknowhim'
 import A6_CHAPTER397TRIPLEKILLINGOFWOODRACE from '@/components/96_chapter397triplekillingofwoodrace'
 import A7_CHAPTER398RAINBOWSCREEN from '@/components/97_chapter398rainbowscreen'
 import A8_CHAPTER399SUPERIORANDINFERIORJUDGEMENT from '@/components/98_chapter399superiorandinferiorjudgement'
 import A9_CHAPTER400SPIRITCRYSTALTHESIZEOFAHEAD from '@/components/99_chapter400spiritcrystalthesizeofahead'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter301tuskdescending",
 			"name" : "0_chapter301tuskdescending",
 			"component" : A_CHAPTER301TUSKDESCENDING
 		},
 		{
 			"path" : "/1_chapter302savethepoorofasmalltown",
 			"name" : "1_chapter302savethepoorofasmalltown",
 			"component" : A_CHAPTER302SAVETHEPOOROFASMALLTOWN
 		},
 		{
 			"path" : "/2_chapter303rallying",
 			"name" : "2_chapter303rallying",
 			"component" : A_CHAPTER303RALLYING
 		},
 		{
 			"path" : "/3_chapter304inthenameoftheqinemperor",
 			"name" : "3_chapter304inthenameoftheqinemperor",
 			"component" : A_CHAPTER304INTHENAMEOFTHEQINEMPEROR
 		},
 		{
 			"path" : "/4_chapter305mysteriousman",
 			"name" : "4_chapter305mysteriousman",
 			"component" : A_CHAPTER305MYSTERIOUSMAN
 		},
 		{
 			"path" : "/5_chapter306crosscounting",
 			"name" : "5_chapter306crosscounting",
 			"component" : A_CHAPTER306CROSSCOUNTING
 		},
 		{
 			"path" : "/6_chapter307yangtiansdanger",
 			"name" : "6_chapter307yangtiansdanger",
 			"component" : A_CHAPTER307YANGTIANSDANGER
 		},
 		{
 			"path" : "/7_chapter308mysteriousinjection",
 			"name" : "7_chapter308mysteriousinjection",
 			"component" : A_CHAPTER308MYSTERIOUSINJECTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js